import { Gift, MapPin, Store, Loader2, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

function ConciergeVisual() {
  return (
    <div className="flex h-56 flex-col justify-center gap-4 rounded-2xl bg-ink p-6">
      <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-white">
          <Gift size={15} />
        </div>
        <p className="text-xs text-white/80">Vous nous envoyez vos infos et votre logo</p>
      </div>
      <span className="pl-11 text-white/20">↓</span>
      <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-white">
          <Loader2 size={15} />
        </div>
        <p className="text-xs text-white/80">On configure votre carte pour vous</p>
      </div>
      <span className="pl-11 text-white/20">↓</span>
      <div className="flex items-center gap-2.5 rounded-xl bg-white/95 p-3 shadow-xl">
        <Check size={15} className="shrink-0 text-mint-text" />
        <p className="text-xs font-semibold text-ink">Prête en moins de 20 minutes</p>
      </div>
    </div>
  );
}

function DirectoryVisual() {
  const shops = [
    { name: "Boulangerie Le Fournil", type: "Boulangerie" },
    { name: "Salon Belle Coiffure", type: "Coiffeur" },
    { name: "Café des Amis", type: "Café" },
  ];
  return (
    <div className="grid grid-cols-1 gap-2.5 rounded-2xl bg-ink p-6 sm:h-56 sm:grid-cols-3">
      {shops.map((s) => (
        <div key={s.name} className="flex flex-col items-start justify-center gap-1.5 rounded-xl bg-white/95 p-3 shadow-xl">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-cream-deep text-ink">
            <Store size={13} />
          </div>
          <p className="text-[11px] font-bold leading-tight text-ink">{s.name}</p>
          <p className="text-[10px] text-ink-soft">{s.type}</p>
        </div>
      ))}
    </div>
  );
}

const rows = [
  {
    icon: Gift,
    accent: "bg-orange/10 text-orange",
    tag: "Concierge",
    title: "On configure votre carte à votre place.",
    description:
      "Envoyez-nous votre logo et vos couleurs, on s'occupe du reste — votre programme de fidélité est prêt à afficher en caisse en moins de 20 minutes.",
    visual: <ConciergeVisual />,
  },
  {
    icon: MapPin,
    accent: "bg-mint/10 text-mint-text",
    tag: "Découverte",
    title: "Un annuaire public pour attirer de nouveaux clients.",
    description:
      "Votre commerce apparaît dans l'annuaire Wara Cards — les visiteurs qui cherchent une carte de fidélité près de chez eux vous découvrent, sans que vous ayez rien à faire.",
    visual: <DirectoryVisual />,
  },
];

export function GrowthFeatures() {
  return (
    <section className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Croissance</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Au-delà de la fidélité,
            <br />
            <span className="text-gradient">de vrais leviers d'acquisition.</span>
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Wara Cards ne fait pas que retenir vos clients existants — il aide à en amener de
            nouveaux.
          </p>
        </Reveal>

        <div className="mt-16 flex flex-col gap-16">
          {rows.map((row, i) => (
            <div key={row.tag} className="grid items-center gap-10 lg:grid-cols-2">
              <Reveal delay={0.1} className={i % 2 === 1 ? "lg:order-2" : ""}>
                <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wide ${row.accent}`}>
                  <row.icon size={14} />
                  {row.tag}
                </span>
                <h3 className="mt-4 text-2xl font-extrabold tracking-tight text-ink">{row.title}</h3>
                <p className="mt-3 text-ink-soft">{row.description}</p>
              </Reveal>

              <Reveal delay={0.15} className={i % 2 === 1 ? "lg:order-1" : ""}>
                {row.visual}
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
